import axios from "axios";
import {metaApiUrl} from "@/apiUrls/metaApiUrls";

export const initializeFacebookSDK = () => {
    return new Promise<void>((resolve) => {
        if (window.FB) {
            window.FB.init({
                appId: process.env.REACT_APP_FACEBOOKAPP_ID || '',
                cookie: true,
                xfbml: true,
                version: 'v21.0',
            });
            resolve();
        } else {
            const script = document.createElement('script');
            script.src = "https://connect.facebook.net/en_US/sdk.js";
            script.async = true;
            script.onload = () => {
                console.log("Facebook SDK loaded, initializing...");
                window.FB.init({
                    appId: process.env.REACT_APP_FACEBOOKAPP_ID || '',
                    cookie: true,
                    xfbml: true,
                    version: 'v21.0',
                });
                resolve();
            };
            document.body.appendChild(script);
        }
    });
};

// 短期トークンを取得するための関数
export const facebookLogin = (): Promise<string | null> => {
    return new Promise((resolve) => {

        window.FB.login((response) => {

            if (response.authResponse) {
                const shortLivedToken = response.authResponse.accessToken;
                resolve(shortLivedToken); // 短期トークンを返す
            } else {resolve(null);
            }
        }, { scope: 'instagram_basic,instagram_manage_insights,pages_show_list,pages_read_engagement,pages_messaging,instagram_manage_messages,instagram_manage_comments' });
    });
};

// 長期アクセストークンを取得するための非同期関数
export const obtainLongLivedToken = async (shortLivedToken: string): Promise<string | null> => {
    const appId = process.env.REACT_APP_FACEBOOKAPP_ID;
    const appSecret = process.env.REACT_APP_FACEBOOKAPP_SECRET;
    const url = metaApiUrl + `oauth/access_token`;
    const params = {
        grant_type: 'fb_exchange_token',
        client_id: appId,
        client_secret: appSecret,
        fb_exchange_token: shortLivedToken,
    };

    try {
        const response = await axios.get(url, { params });
        const longLivedToken = response.data.access_token;
        return longLivedToken;
    } catch (error) {
        return null;
    }
};

export const getPageId = async (accessToken: string): Promise<string | null> => {
    return new Promise((resolve) => {
        window.FB.api('/me/accounts', 'GET', { access_token: accessToken }, (res: any) => {
            if (res && res.data && res.data.length > 0) {
                resolve(res.data[0].id); // 最初のページのIDを返す
            } else {
                resolve(null);
            }
        });
    });
};

export async function getPageIdFromInstagramId(instagramId: string, accessToken: string): Promise<string | null> {
    try {
        // Instagram ID が有効かどうかだけ確認（optional: 実際には使っていないが検証の意味で残す）
        const igResponse = await fetch(metaApiUrl + `${instagramId}?fields=id,username&access_token=${accessToken}`);
        const igData = await igResponse.json();

        if (!igData || !igData.id) {
            return null;
        }

        // Facebookページ一覧を取得
        const res = await fetch(metaApiUrl + `me/accounts?fields=accounts&access_token=${accessToken}`);
        const data = await res.json();

        console.log(data)

        if (!data?.data || !Array.isArray(data.data) || data.data.length === 0) {
            return null;
        }

        // 最初のページIDをそのまま使用
        const firstPageId = data.data[0].id;
        return firstPageId;
    } catch (error) {
        return null;
    }
}